import React from 'react';
import cx from 'classnames';
import css from './Status.module.scss';
import { EStatus } from '../../../../store/reducers/enumTypes';

export const Status = ({ status }: { status: EStatus }) => (
  <div className={cx(css.root, css[status.toLowerCase()])}>{status}</div>
);
